export const rootNode = document.getElementById('marketing-finance-app-comparisons-root');

export const initParams = {
  data: JSON.parse(rootNode.dataset.data),
};
